<template>
<div class="chapter">
<div class="inner_page">
<h1>Contents</h1>
<p class="p13"><span class="t0"><img alt="img2.png" height="155" src="images/img2.png" width="441"/></span></p>
<p class="p13"><span class="t0">Chapter 1</span></p>
<p class="p16"><span class="t0">The Vacant Chai</span></p>
<p class="p7"><span class="t0">Chapter 2</span></p>
<p class="p16"><span class="t0">Is It Too Early for Wine?</span></p>
<p class="p7"><span class="t0">Chapter 3</span></p>
<p class="p16"><span class="t0">A Papal See of Red</span></p>
<p class="p7"><span class="t0">Chapter 4</span></p>
<p class="p16"><span class="t0">Better Get a Bale of Hay</span></p>
<p class="p7"><span class="t0">Chapter 5</span></p>
<p class="p16"><span class="t0">I Hope They Know What They’ve Done</span></p>
<p class="p7"><span class="t0">Chapter 6</span></p>
<p class="p16"><span class="t0">A New Dawn</span></p>
<p class="p7"><span class="t0">Chapter 7</span></p>
<p class="p16"><span class="t0">Pope for a Day</span></p>
<p class="p7"><span class="t0">Chapter 8</span></p>
<p class="p16"><span class="t0">I’ve Got a Secret</span></p>
<p class="p7"><span class="t0">Chapter 9</span></p>
<p class="p16"><span class="t0">Ain’t We Got Fun?</span></p>
<p class="p7"><span class="t0">Chapter 10</span></p>
<p class="p16"><span class="t0">Dungeons and Cardinals</span></p>
<p class="p7"><span class="t0">Chapter 11</span></p>
<p class="p16"><span class="t0">The Devil Is in the Details</span></p>
<p class="p7"><span class="t0">Chapter 12</span></p>
<p class="p16"><span class="t0">Something Smelly This Way Comes</span></p>
<p class="p7"><span class="t0">Chapter 13</span></p>
<p class="p16"><span class="t0">Sulfur and Candlesticks</span></p>
<p class="p7"><span class="t0">Chapter 14</span></p>
<p class="p16"><span class="t0">Is This What Normal Feels Like?</span></p>
<p class="p7"><span class="t0">Chapter 15</span></p>
<p class="p16"><span class="t0">Washington in the Summer Is a Wretched Place</span></p>
<p class="p7"><span class="t0">Chapter 16</span></p>
<p class="p16"><span class="t0">The White House Blues</span></p>
<p class="p7"><span class="t0">Chapter 17</span></p>
<p class="p16"><span class="t0">Spanish Moss</span></p>
<p class="p7"><span class="t0">Chapter 18</span></p>
<p class="p16"><span class="t0">Summer on the Lake</span></p>
<p class="p7"><span class="t0">Chapter 19</span></p>
<p class="p16"><span class="t0">Present, Past, and Future</span></p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007.vue?46081a0c